import { SvgIcon } from "@mui/material";

export default function RunToCursorIcon() {
    return (
        <SvgIcon viewBox="0 0 16 16">
            <path d="M1.99217,3.11737 L10.40217,8.03737 L1.99217,12.95737 Z" />
            <path d="m10.01,3.04l0,-1.03l4.03,0l0,1.03l-4.03,0z" />
            <path d="M11.29,3.02h1.47v9.99h-1.47z" />
            <path d="m10.01,13.98l0,-1.03l4.03,0l0,1.03l-4.03,0z" />
        </SvgIcon>
    );
}
